import * as React from 'react';

import { FormikErrors, FormikProps, withFormik } from "formik";
import { ServiceObjectTypeAttachAccount, ServiceObjectTypeNumber } from '../../../../models/SettingModels';

import { AttachPersonalAccountCommand } from '../../../../models/AccountModels';
import Input from '../../../components/Input';
import { ServiceObjectAddressLayout } from '../../../../models/ServiceObjectModels';
import ServiceObjectSearch from '../../../generic/component/ServiceObjectSearch';
import { Spinner } from '../../../components/Loader';
import validator from 'validator';

interface AccountAttachFormProps {
    isProgress: boolean,
    serviceObjectTypeNumber: ServiceObjectTypeNumber | null;
    serviceObjectTypeAttachAccount: ServiceObjectTypeAttachAccount | null;
    AttachPersonalAccount(command: AttachPersonalAccountCommand): Promise<void>;
}

interface AccountAttachFormValue {
    serviceObject: ServiceObjectAddressLayout | null;
    personalAccount: string | null;
}


class AccountAttachForm extends React.PureComponent<AccountAttachFormProps & FormikProps<AccountAttachFormValue>>{

    render(): React.ReactNode {
        const {
            errors, 
            handleSubmit,
            setFieldValue,
            values,
        } = this.props;

        return <React.Fragment>
            <div className='attach'>
                <div className='modal-header-large'>Добавление лицевого счета</div>

                <div className='name-passive--8 small'>Введите и выберите пошагово:<br /> Населённый пункт, улицу, дом, подъезд, квартиру</div>
                <ServiceObjectSearch
                    serviceObject={null}
                    isValid={errors.serviceObject === undefined}
                    serviceObjectTypeNumber={this.props.serviceObjectTypeNumber ? this.props.serviceObjectTypeNumber : undefined}
                    SetServiceObject={(e) => { setFieldValue("serviceObject", e, true) }} />
                <div className='name-passive--8 small'> полный, двенадцатизначный лицевой счёт</div>
                <div>

                    <Input type='number' onChange={(value) => { setFieldValue("personalAccount", value, true) }} placeholder='Лицевой счет' />
                    <div className={`attach__button button button-text ${!this.props.isValid && "disabled"}`}
                        onClick={() => { if (this.props.isValid) handleSubmit() }}>
                        {this.props.isProgress ? <Spinner />
                            : "Добавить"}</div>
                </div>

            </div>
        </React.Fragment>

    }
}



export default withFormik<AccountAttachFormProps, AccountAttachFormValue>({
    enableReinitialize: false,
    validateOnMount: true,
    validateOnChange: true,
    mapPropsToValues: (props: AccountAttachFormProps) => ({
        serviceObject: null,
        personalAccount: null,
    }),
    validate: (values: AccountAttachFormValue, props: AccountAttachFormProps) => {
        let errors: FormikErrors<AccountAttachFormValue> = {};


        if (!values.serviceObject) {
            errors.serviceObject = 'адрес не выбран'

        }
        else if (!props.serviceObjectTypeAttachAccount?.types?.some(x => x === values.serviceObject?.serviceObjectType || '')) {
            errors.serviceObject = 'адрес не выбран'

        }
        if (validator.isEmpty(values.personalAccount || '', { ignore_whitespace: true })) {
            errors.personalAccount = 'обязательное поле'
        }
        else if (!validator.isNumeric(values.personalAccount || '')) {
            errors.personalAccount = 'неверный формат числа'

        }
        else if (values.personalAccount?.length != 12) {
            errors.personalAccount = 'неверный формат числа'

        }


        return errors;
    },
    handleSubmit: async (
        valuesForm: AccountAttachFormValue,
        { props, setSubmitting, setErrors, setStatus, resetForm, validateForm, setFieldValue }
    ) => {
        if (valuesForm.personalAccount !== null &&
            valuesForm.serviceObject !== null &&
            valuesForm.serviceObject.serviceObjectId !== null) {
            await props.AttachPersonalAccount({
                serviceObjectId: valuesForm.serviceObject.serviceObjectId,
                personalAccount: Number(valuesForm.personalAccount)
            })
        }

    }
}

)(AccountAttachForm);